import { gsap } from 'gsap';
gsap.config({ nullTargetWarn: false });
/** TL Banner */
// var tlBanner = gsap.timeline({ paused: true });
// tlBanner
//   .from(".home .hero_slider", { duration: 0.5, opacity: 0 })
//   .from(".home .hero_mask", { duration: 0.5, x: "-100%", ease: "back.out(0.8)", opacity: 1 }, "-=1")
//   .from(".home .hero_redline", { duration: 0.3, x: "100%", ease: "back.out(0.2)", opacity: 0, visibility: "invisible" }, "-=1")
//   .from(".home .hero_lines", { duration: 0.5, y: 800, ease: "back.out(0.8)", opacity: 0 }, "-=1")
//   .from(".home .hero_slogan h1", { duration: 0.3, y: 50, ease: "back.out(0.8)", opacity: 0 }, "-=0.8")
//   .from(".home .hero_slogan .hero_slogan_topline", { duration: 0.3, y: 50, ease: "back.out(0.8)", opacity: 0 }, "-=0.7")
//   .from(".home .topbar", { duration: 0.5, y: -25, ease: "back.out(0.8)", opacity: 0, visibility: "invisible" }, "-=0.6")
//   .from(".home .hero_baseline", { duration: 0.5, ease: "none", opacity: 0 }, "-=0.5");

/** TL Services */
var tlServices = gsap.timeline({ paused: true });
tlServices.staggerFrom(".services_list li", 0.3, { y: 50, opacity: 0 }, 0.1);

/** TL News */
var tlNews = gsap.timeline({ paused: true });
tlNews.staggerFrom(".feed-item", 0.3, { y: 50, opacity: 0 }, 0.1);

/** TL Gamme */
var tlGammesInit = gsap.timeline({ paused: true });
var tlGammesActive = gsap.timeline();

tlGammesInit
  .fromTo(
    ".gamme_model--picture.active",
    0.5,
    { x: "500", autoAlpha: 0 },
    { x: "0", ease: "back.out(0.8)", autoAlpha: 1 }
  )
  .fromTo(
    ".gamme_model.active",
    0.5,
    { x: "500", autoAlpha: 0 },
    { x: "0", ease: "back.out(0.8)", autoAlpha: 1 },
    "-=0.4"
  );

var tlGammesInactive = gsap.timeline();

function ChangeModel(vehicule) {
  
  if (vehicule.hasClass("active")) return;
  $(".gamme_list li > a.inactive").removeClass("inactive");
  $(".gamme_list li > a.active").addClass("inactive");
  $(".gamme_list li > a").removeClass("active");

  if (vehicule.hasClass("gamme_list_activemodel")) {
    vehicule.data("model", vehicule.val());
  }
  var model = "";
  $(".gamme_list_activemodel").not(vehicule).val("");
  var model = vehicule.data("model");

  console.log(model);
  $(".gamme_model.inactive").removeClass("inactive");
  $(".gamme_model.active").addClass("inactive");
  $(".gamme_model").removeClass("active");
  $('.gamme_model[data-model="' + model + '"]').addClass("active");

  $(".gamme_model--picture.inactive").removeClass("inactive");
  $(".gamme_model--picture.active").addClass("inactive");
  $(".gamme_model--picture").removeClass("active");
  $('.gamme_model--picture[data-model="' + model + '"]').addClass("active");

  tlGammesInactive
    .to(".gamme_model--picture.inactive", 0.5, {
      x: "-500",
      ease: "back.out(0.8)",
      autoAlpha: 0,
    })
    .to(
      ".gamme_model.inactive",
      0.5,
      { x: "-500", ease: "back.out(0.8)", autoAlpha: 0 },
      "-=0.4"
    );

  tlGammesActive
    .fromTo(
      ".gamme_model--picture.active",
      0.5,
      { x: "500", autoAlpha: 0 },
      { x: "0", ease: "back.out(0.8)", autoAlpha: 1 }
    )
    .fromTo(
      ".gamme_model.active",
      0.5,
      { x: "500", autoAlpha: 0 },
      { x: "0", ease: "back.out(0.8)", autoAlpha: 1 },
      "-=0.4"
    );
}
// click ul li
$(".gamme_list li>a").on("click", function (e) {
  e.preventDefault();
  ChangeModel($(this));
});
// click select
$(".gamme_list_activemodel").on("change", function () {
  ChangeModel($(this));
});

/** TL Models */
var tlModels = gsap.timeline();

//Page nos marques logos
$(".models_list--logo a").on("click", function (e) {
  e.preventDefault();
  $(".models_list--logo a").removeClass("active");
  $(this).addClass("active");
  var listname = $(this).data("gamme");

  $(".gamme_list").removeClass("active");
  $(".gamme_list_activemodel").removeClass("showme");
  $('.gamme_list[data-gamme="' + listname + '"]').addClass("active");
  $('.gamme_list_activemodel[data-gamme="' + listname + '"]').addClass(
    "showme"
  );

  tlModels.staggerFrom(
    ".models_list .gamme_list.active li",
    0.2,
    { y: 50, opacity: 0 },
    0.1
  );
});

/** Init animations **/
$(document).ready(function () {
  // tlBanner.play();
});

if (
  $("section.services").isOnScreen(0.4, 0.4) ||
  $(".page-template-services").length
) {
  tlServices.play();
}
if ($("section.news").isOnScreen(0.4, 0.4) || $(".page-template-news").length) {
  tlNews.play();
}
if ($("section.gamme").isOnScreen(0.4, 0.4)) {
  tlGammesInit.play();
}
if ($("section.models").isOnScreen(0, 0)) {
  tlGammesInit.play();
}

window.onscroll = function () {
  if ($("section.services").isOnScreen(0.4, 0.4)) {
    tlServices.play();
  }
  if ($("section.gamme").isOnScreen(0, 0)) {
    tlGammesInit.play();
  }
  if ($("section.news").isOnScreen(0.4, 0.4)) {
    tlNews.play();
  }
};

// Burger
/** TL menu */
var tlMenuItems = gsap.timeline({ paused: true });
tlMenuItems.staggerTo(".topbar_nav ul li a", 0.2, { y: 0, autoAlpha: 1 }, 0.1);

$(".topbar--burger").on("click", function (e) {
  e.preventDefault();
  $("body").toggleClass("menu-active");
  $(".topbar_nav").toggleClass("menu-active");

  $(this).toggleClass("active");

  tlMenuItems.pause(0);
  tlMenuItems.play();

  $(".topbar").toggleClass("menu-active");
  $(".menu-principal-container").toggleClass("menu-active");
});